import { render } from "./InfoModal.vue?vue&type=template&id=0561dde6&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=0561dde6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0561dde6"]])

export default __exports__